import { getEnvRequired } from '../../shared/utilities/env';

import { serializeDossierOverviewFromAPI } from '../dossier/serializers';
import { ApiClient } from '../shared/api/client';

import { DossierOverviewsJSONAPIResponse } from './types';

const apiClient = new ApiClient(true);

export async function fetchDossierOverviews() {
    const REQUEST_MANAGER_API_URL = getEnvRequired('REQUEST_MANAGER_API_URL');
    const url = `${REQUEST_MANAGER_API_URL}/open-requests/dossier-overview?include=tags`;
    const response = await apiClient.get<DossierOverviewsJSONAPIResponse>(url);
    return serializeDossierOverviewFromAPI(response);
}

export async function fetchArchivedDossierOverviews(query?: string | null) {
    const REQUEST_MANAGER_API_URL = getEnvRequired('REQUEST_MANAGER_API_URL');
    let url = `${REQUEST_MANAGER_API_URL}/archived-requests/dossier-overview`;
    if (query) {
        url += `?query=${encodeURIComponent(query.trim())}`;
    }
    const response = await apiClient.get<DossierOverviewsJSONAPIResponse>(url);
    return serializeDossierOverviewFromAPI(response);
}
